"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "agrigento": {
    "c3f51b17": [{
      "hkey": "6b8d65f4",
      "slug": "fontanelle-san-giusippuzzu",
      "name": "Fontanelle-San Giusippuzzu",
      "primary": true,
      "skipSearch": false
    }],
    "fontanelle": [{
      "hkey": "6b8d65f4",
      "slug": "fontanelle-san-giusippuzzu",
      "name": "Fontanelle-San Giusippuzzu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1e62f63b": [{
      "hkey": "a191ec5e",
      "slug": "san-leone",
      "name": "San Leone",
      "primary": true,
      "skipSearch": false
    }],
    "mare-san-leone": [{
      "hkey": "a191ec5e",
      "slug": "san-leone",
      "name": "San Leone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "agrigento"
    }],
    "908cb807": [{
      "hkey": "64655506",
      "slug": "agrigento",
      "name": "Agrigento",
      "primary": true,
      "skipSearch": false
    }],
    "monserrato": [{
      "hkey": "64655506",
      "slug": "agrigento",
      "name": "Agrigento",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "66d6c290": [{
      "hkey": "6b8d65f4",
      "slug": "fontanelle-san-giusippuzzu",
      "name": "Fontanelle-San Giusippuzzu",
      "primary": true,
      "skipSearch": false
    }],
    "periferia": [{
      "hkey": "6b8d65f4",
      "slug": "fontanelle-san-giusippuzzu",
      "name": "Fontanelle-San Giusippuzzu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "agrigento"
    }],
    "c4c6c693": [{
      "hkey": "6b8d65f4",
      "slug": "fontanelle-san-giusippuzzu",
      "name": "Fontanelle-San Giusippuzzu",
      "primary": true,
      "skipSearch": false
    }],
    "sangiusippuzzo": [{
      "hkey": "6b8d65f4",
      "slug": "fontanelle-san-giusippuzzu",
      "name": "Fontanelle-San Giusippuzzu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "agrigento"
    }],
    "b1f600f9": [{
      "hkey": "64655506",
      "slug": "agrigento",
      "name": "Agrigento",
      "primary": true,
      "skipSearch": false
    }],
    "villa-seta": [{
      "hkey": "64655506",
      "slug": "agrigento",
      "name": "Agrigento",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;